import Vue from 'vue'
import VueRouter from 'vue-router'
import { getOpenid} from '../api/pay'
import SharePage from '../views/page/sharePage'
import ShareDynamic from '../views/page/shareDynamic'
import BrowserOpen from '../views/page/browserOpen'
import OffSiteSharing from '../views/page/offSiteSharing'
import CustomerRecharge from '../views/page/customerRecharge'
import UsAgreement from '../views/page/usAgreement'
import DiamondRecharge from '../views/page/diamondRecharge'
import axios from 'axios'
import NotFound from '../views/notfound/index'

Vue.use(VueRouter)

const routes = [

    { // 主页分享
        path: '/sharePage',
        name: 'sharePage',
        component: SharePage,
        meta: {
            auth: false,
        }
    },
    { // 动态分享
        path: '/shareDynamic',
        name: 'shareDynamic',
        component: ShareDynamic,
        meta: {
            auth: false,
        }
    },
    { // 浏览器打开
        path: '/browserOpen',
        name: 'browserOpen',
        component: BrowserOpen,
        meta: {
            auth: false,
        }
    },
    { // 站外分享
        path: '/offSiteSharing',
        name: 'offSiteSharing',
        component: OffSiteSharing,
        meta: {
            auth: false,
        }
    },
    { // 客服充值
        path: '/customerRecharge',
        name: 'customerRecharge',
        component: CustomerRecharge,
        meta: {
            auth: false,
        }
    },
    { // 展示协议
        path: '/UsAgreement',
        name: 'UsAgreement',
        component: UsAgreement,
        meta: {
            auth: false,
        }
    },
    { // 展示协议
        path: '/diamondRecharge',
        name: 'diamondRecharge',
        component: DiamondRecharge,
        meta: {
            auth: false,
        }
    },
    // {
    //     path: '/news',
    //     name: 'news',
    //     component: News,
    //     meta: {
    //         auth: false,
    //     }
    // },

    // {
    //     path: '/detail/:id',
    //     name: 'detail',
    //     component: Detail,

    //     meta: {
    //         auth: false,
    //     }
    // },

    // {
    //     path: '/knowledge',
    //     name: 'knowledge',
    //     component: Knowledge,
    //     meta: {
    //         auth: false,
    //     }
    // },

    // {
    //     path: '/page/list',
    //     name: 'pagelist',
    //     component: PageList,
    //     meta: {
    //         auth: false,
    //     }
    // },

    // {
    //     path: '/page/:id',
    //     name: 'page',
    //     component: Page,
    //     meta: {
    //         auth: false,
    //     }
    // },


    // {
    //     path: '/profile',
    //     name: 'profile',
    //     component: Profile,
    //     meta: {
    //         auth: true,
    //     }
    // },

    // {
    //     path: '/show/collects',
    //     name: 'collect',
    //     component: Collect,
    //     meta: {
    //         auth: true,
    //     }
    // },

    // {
    //     path: '/show/myexams',
    //     name: 'myexams',
    //     component: MyExams,
    //     meta: {
    //         auth: true,
    //     }
    // },

    // {
    //     path: '/show/examinfo/:id',
    //     name: 'examinfo',
    //     component: ExamInfo,
    //     meta: {
    //         auth: true,
    //     }
    // },

    // {
    //     path: '/show/comments',
    //     name: 'comments',
    //     component: Comments,
    //     meta: {
    //         auth: true,
    //     }
    // },



    // {
    //     path: '/login',
    //     name: 'login',
    //     component: Login,
    //     meta: {
    //         auth: false,
    //     }
    // },

    // {
    //     path: '/register',
    //     name: 'register',
    //     component: Register,
    //     meta: {
    //         auth: false,
    //     }
    // },

    // {
    //     path: '/setting',
    //     name: 'setting',
    //     component: Setting,
    //     meta: {
    //         auth: true,
    //     }
    // },

    // {
    //     path: '/password',
    //     name: 'password',
    //     component: Password,
    //     meta: {
    //         auth: true,
    //     }
    // },


    // 404页面，定义在最底部
    {
        path: '*',
        name: 'notfound',
        component: NotFound,
        meta: {
            auth: false,
        }
    }

]

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'tab-active',
    routes
})

router.beforeEach((to, from, next) => {
    var userAgent = navigator.userAgent.toLowerCase();

    // 判断是否在微信中打开
    if (userAgent.indexOf('micromessenger') !== -1) {
        if(to.query.code){
            getOpenid({code:to.query.code}).then(res=>{
                next({
                    path:'diamondRecharge',
                    query:{
                        wxid: res.data
                    }
                }); 
            })
        }else{
            next();    
        }
    
    } else {
        next();
    }
    console.log(to,9)
    next();
    // // 判断用户是否登录
    // if (to.path != '/login' && to.meta.auth && !localStorage.getItem('token')) {
    //     next('/login');
    //     return;

    // } else if (to.path == '/login' && localStorage.getItem('token')) {
    //     next(from);
    //     return;
    // } else {
    //    
    // }

})

export default router
